module.exports = __webpack_public_path__ + "static/media/FacistBoard_medium_6.864fd415.png";